/**
 * EventEditDialog — dialog modifica evento del Calendario.
 * ★ Fase 59.P2 — estratto da CalendarPage.jsx. Comportamento e testid invariati.
 */
import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../ui/select';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from '../ui/dialog';
import { EVENT_TYPE_FILTERS } from './calendarUtils';
import i18n from '../../i18n';

export function EventEditDialog({ editEvent, editForm, setEditForm, onClose, onSave }) {
  return (
    <Dialog open={!!editEvent} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-md" data-testid="event-edit-dialog">
        <DialogHeader>
          <DialogTitle>{i18n.t('calendarX.editEvent', 'Modifica evento')}</DialogTitle>
        </DialogHeader>
        {editForm && (
          <div className="space-y-3">
            <div>
              <Label className="text-xs uppercase tracking-wide">{i18n.t('calendarX.eventTitle', 'Titolo')}</Label>
              <Input
                value={editForm.title}
                onChange={(e) => setEditForm({ ...editForm, title: e.target.value })}
                className="mt-1"
                data-testid="event-edit-title"
              />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-wide">{i18n.t('calendar.edit.fields.type', 'Tipo')}</Label>
              <Select value={editForm.type} onValueChange={(v) => setEditForm({ ...editForm, type: v })}>
                <SelectTrigger className="mt-1" data-testid="event-edit-type">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {EVENT_TYPE_FILTERS.slice(1).map((t) => (
                    <SelectItem key={t.value} value={t.value}>{t.label}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label className="text-xs uppercase tracking-wide">{i18n.t('calendarX.dateTime', 'Data e ora')}</Label>
              <Input
                type="datetime-local"
                value={editForm.event_at}
                onChange={(e) => setEditForm({ ...editForm, event_at: e.target.value })}
                className="mt-1"
                data-testid="event-edit-datetime"
              />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-wide">{i18n.t('calendarX.status', 'Stato')}</Label>
              <Select value={editForm.status} onValueChange={(v) => setEditForm({ ...editForm, status: v })}>
                <SelectTrigger className="mt-1">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="pending">{i18n.t('calendarX.scheduled', 'In programma')}</SelectItem>
                  <SelectItem value="done">{i18n.t('calendarX.done', 'Completato')}</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label className="text-xs uppercase tracking-wide">{i18n.t('calendarX.notesSingle', 'Note (campo singolo)')}</Label>
              <Textarea
                rows={2}
                value={editForm.notes}
                onChange={(e) => setEditForm({ ...editForm, notes: e.target.value })}
                className="mt-1"
                data-testid="event-edit-notes"
              />
              <div className="text-[10px] text-muted-foreground mt-1">
                {i18n.t('calendarX.multiNotesHint', 'Per aggiungere trascrizioni multiple, usa il bottone "+" sull\'evento.')}
              </div>
            </div>
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            {i18n.t('common.cancel', 'Annulla')}
          </Button>
          <Button onClick={onSave} data-testid="event-edit-save">{i18n.t('common.save', 'Salva')}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
